<template>
  <div class="list-header row align-items-center">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    windowWidth: { type: Number },
  },
};
</script>

<style scoped lang="scss">
.list-header {
  padding: 0.6rem 1rem;
  color: $secondary;
}
</style>
